export const BROADCAST_DELAY_MINUTES = 10;

export const BROADCAST_MIN_SCHEDULED_TIME_MINUTES = 30; // 30 minutes

export const BROADCAST_SEND_TYPE = {
  NOW: "now",
  SCHEDULED: "scheduled",
};

export const BROADCAST_STATUS = {
  ERROR: "ERROR",
  FINISHED: "FINISHED",
  IN_PROGRESS: "IN_PROGRESS",
  SCHEDULED: "SCHEDULED",
  PAUSED: "PAUSED",
  CANCELED: "CANCELED",
  WAITING_FOR_APPROVAL_TEMPLATE: "WAITING_FOR_APPROVAL_TEMPLATE",
};
